import { Handle, Position } from '@xyflow/react'

const SIDES = [Position.Top, Position.Right, Position.Bottom, Position.Left] as const

/** Four connection dots, shown on hover/selection. Edges themselves float (see FloatingEdge). */
export function Handles() {
  return (
    <>
      {SIDES.map((p) => (
        <Handle key={p} id={p} type="source" position={p} className="moot-handle" />
      ))}
    </>
  )
}
